/**
 * #3115 — accept a post-sign-in destination ONLY if it is an in-app path.
 *
 * <p>The sign-in gate stashes `location.pathname + location.search` in sessionStorage before the
 * MSAL redirect, and `/auth/callback` reads it back. A crafted URL such as
 * `https://<app>//evil.example/x` puts `//evil.example/x` in `location.pathname`, so the stash is
 * treated as untrusted on the way out. A bare `/…` is a same-document navigation; `//host` and
 * `/\host` are protocol-relative URLs a browser resolves to ANOTHER origin, which is the classic
 * open-redirect. Anything else (an absolute URL, an empty or missing value) falls back to the
 * caller's default.</p>
 *
 * <p>The same rules as subject-surface's `safeReturnTo` (apps/subject-surface/src/auth/msalConfig.ts).
 * The three MSAL apps share no non-UI package, so each carries its own copy of this one function.</p>
 */
export function safeReturnTo(value: string | null | undefined, fallback: string): string {
  if (typeof value !== "string" || value.length === 0) return fallback;
  if (!value.startsWith("/")) return fallback;
  if (value.startsWith("//") || value.startsWith("/\\")) return fallback;
  return value;
}
